/* eslint-disable import/prefer-default-export */

export function normalizeFilters(state) {
  const filtersAndSort = {};
  const other = {};
  if (state) {
    const parsed = JSON.parse(state);
    Object.keys(parsed).forEach(property => {
      if (['buildings', 'sites'].indexOf(property) === -1) {
        other[property] = parsed[property];
        return;
      }
      const filters = new Map(parsed[property].filters);
      filtersAndSort[property] = {
        ...parsed[property],
        filters,
      };
    });
  }
  return { filtersAndSort, other };
}



// WEBPACK FOOTER //
// ./src/utils/normalizeFilters.js